<template>
  <form :action="formPath" method="POST">
    <input :value="csrfToken" type="hidden" name="authenticity_token" />
    <input type="hidden" name="user[remember_me]" value="true" />
    <div class="row">
      <div class="col-xs-24 col-md-16">
        <FormInputFloatingLabel
          :required="true"
          :label="t.email"
          v-model="email"
          name="user[email]"
        />
      </div>
      <div class="col-xs-24 col-md-16">
        <FormInputFloatingLabel
          :required="true"
          :label="t.password"
          v-model="password"
          name="user[password]"
          type="password"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-24 col-md-16">
        <FormRecaptcha :parameters="recaptchaParameters" />

        <div class="text-right">
          <a :href="forgotPasswordPath" class="font-weight-bold text-primary small">
            {{ t.forgot_password }}
          </a>
        </div>
      </div>
      <div class="col-md-16">
        <CheckoutButtonCheckout
          :active_text="t.sign_up"
          :inactive_text="t.please_wait"
          class="w-100 ch-Address_Submit"
        ></CheckoutButtonCheckout>
      </div>
    </div>
  </form>
</template>

<script>
import CheckoutButtonCheckout from "./CheckoutButtonCheckout";
import FormInputFloatingLabel from "./FormInputFloatingLabel";
import FormRecaptcha from "./FormRecaptcha";

export default {
  name: "LoginStrategyCredentials",
  components: {
    CheckoutButtonCheckout,
    FormInputFloatingLabel,
    FormRecaptcha,
  },
  props: {
    initialEmail: {
      type: String,
      default: "",
    },
    t: {
      type: Object,
      required: true,
    },
    forgotPasswordPath: {
      type: String,
      required: true,
    },
    recaptchaParameters: {
      type: Object,
      required: true,
    },
    formPath: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: this.initialEmail,
      password: "",
    };
  },
};
</script>
